// import { nanoid } from "nanoid";
import fenikOleg from './fotoID/fenikOleg.png';
import fenikRostislav from './fotoID/fenikRostislav.png';
import kalaturOlena from './fotoID/kalaturOlena.png';
import antonPalashek from './fotoID/antonPalashek.png';
import ugoZapadLogo from './fotoID/Ugo-Zapad.png';
import ninaViun from './fotoID/nina_viun.png';

export const baseMembership = [
  {
    id: '2a18399a-8371-4665-a51b-8e14c7e517a5',
    name: 'Олег',
    surname: 'Феник',
    certNumber: '1479',
    expiredDate: '06/09/2026',
    fotoId: `${fenikOleg}`,
  },
  {
    id: '7d03b1d8-e5d4-4331-b295-36c71ada659d',
    name: 'Ростислав',
    surname: 'Феник',
    certNumber: '1480',
    expiredDate: '06/09/2026',
    fotoId: `${fenikRostislav}`,
  },
  {
    id: '3a83984d-6c55-4fa2-8934-9b31b4dacda5',
    name: 'Олена',
    surname: 'Калатур',
    certNumber: '1481',
    expiredDate: '09/09/2026',
    fotoId: `${kalaturOlena}`,
  },
  {
    id: '3ee7fa10-151f-41b9-89e8-bcd5e5012d40',
    name: 'Антон',
    surname: 'Палашек',
    certNumber: '1482',
    expiredDate: '13/09/2026',
    fotoId: `${antonPalashek}`,
  },
  {
    id: 'c4d54359-90dd-44d1-8ad1-67e0210f8d33',
    name: 'АН',
    surname: '«Юго-Запад»',
    certNumber: '1483',
    expiredDate: '13/09/2026',
    fotoId: `${ugoZapadLogo}`,
  },
  {
    id: '065278a3-d41f-4266-af43-2c2ab359d744',
    name: 'Ніна',
    surname: 'В’юн',
    certNumber: '1484',
    expiredDate: '15/12/2028',
    fotoId: `${ninaViun}`,
  },
];
